import { Page } from "@/components/misc";
import { createFileRoute } from "@tanstack/react-router";
import { FeatureStoreView } from "../-components/feature-store-view";

export const Route = createFileRoute("/warehouse/overview/")({
  component: () => (
    <Page size="full" fill className="min-w-[48rem] space-y-6">
      <Page.TitleContainer>
        <div>
          <Page.Title>Overview</Page.Title>
          <Page.Subtitle>DAG visualization of the feature store</Page.Subtitle>
        </div>
      </Page.TitleContainer>
      <div className="flex-1 min-h-0 overflow-hidden">
        <FeatureStoreView />
      </div>
    </Page>
  ),
});
